import { RESET_APP } from '../../states/page/actions';
import { retailPaymentTypes } from './constants';
import { UPDATE_RETAIL_PAYMENT } from './actions';

export const initialState = {
	from: '',
	to: '',
	amount: '',
	type: retailPaymentTypes.immediate,
};

const actionHandlers = {
	[RESET_APP]: () => ({}),
	[UPDATE_RETAIL_PAYMENT]: (state, { key, value }) => ({ ...state, [key]: value }),
};

const retailPayment = (state = initialState, action) => (actionHandlers[action.type] || ((s) => s))(state, action);

export default retailPayment;
